module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app__content"
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "section__wrapper"
  }, [_c('div', {
    staticClass: "section__content section__copy"
  }, [_c('div', {
    staticClass: "mb-4"
  }, [_c('upload', {
    attrs: {
      "creditName": _vm.creditName,
      "creditLinks": _vm.creditLinks,
      "contact": _vm.contact
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "section__wrapper"
  }, [_c('div', {
    staticClass: "section__content section__copy"
  }, [_c('h2', [_vm._v("Uploader")]), _vm._v(" "), _c('p', [_vm._v("We will apply this "), _c('a', {
    attrs: {
      "href": "https://creativecommons.org/licenses/by-nc-nd/4.0/"
    }
  }, [_vm._v("Creative Commons")]), _vm._v(" licence to your uploaded videos.")]), _vm._v(" "), _c('p', [_vm._v("It states that we will use the video you upload only for this project, that we won't use it commercially, and we'll credit you every time it is shown.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40d70acc","transformToRequire":{"audio":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/upload.vue
// module id = 225
// module chunks = 1